import { USER_REQUEST, USER_ERROR, USER_SUCCESS, USER_LOGOUT } from '../actions/user'
import Vue from 'vue'
import VueX from 'vuex'
// import User from '@/lib/transfer-objects/User'
// import EventBus from '@/event-bus'

Vue.use(VueX)

const state = {
  status: '',
  // profile: {},
  user: null
}

const getters = {
  user (state) {
    return state.user
  }
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}, user) => {
    commit(USER_SUCCESS, user)
  },
  [USER_LOGOUT]: ({commit, dispatch}) => {
    commit(USER_LOGOUT)
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, user) => {
    state.status = 'success'
    state.user = user
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [USER_LOGOUT]: (state) => {
    state.user = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js